/**
* 公司默认自定义页面数据
*/
const companyFrontEndPageDefaultParam = {

  getCompanyFrontEndPageDefaultParam: "/api/getCompanyFrontEndPageDefaultParam",//获取公司默认自定义页面数据
  getCompanyFrontEndPageDefaultParam2: "/api/getCompanyFrontEndPageDefaultParam2",//获取公司默认自定义页面数据
  setCompanyFrontEndPageDefaultParam: "/api/setCompanyFrontEndPageDefaultParam",//设置公司默认自定义页面数据
  deleteCompanyFrontEndPageDefaultParam: "/api/deleteCompanyFrontEndPageDefaultParam",//删除公司默认自定义页面数据
}

export default companyFrontEndPageDefaultParam